import con from '../../../connection';
var path = '/exclusive';
var exclusive = function (url) { return function () { return ({
    delete: function (email) { return con.delete(url + path + '/' + email, {}); },
}); }; };
export default exclusive;
